import { render, staticRenderFns } from "./box-product.vue?vue&type=template&id=5e6f337d&scoped=true&"
import script from "./box-product.vue?vue&type=script&lang=js&"
export * from "./box-product.vue?vue&type=script&lang=js&"
import style0 from "./box-product.vue?vue&type=style&index=0&id=5e6f337d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e6f337d",
  null
  
)

export default component.exports